import {Shop} from '../models/middleware';

const WEEKDAY_KEYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
] as const;

export type WeekdayKey = (typeof WEEKDAY_KEYS)[number];

export const getTodayWeekdayKey = (now: Date = new Date()): WeekdayKey =>
  WEEKDAY_KEYS[now.getDay()];

// Salesforce serves trading hours either as "HH:MM:SS" or already-formatted
// localized strings (e.g. "9:00 AM"). HH:MM:SS gets formatted to en-US 12h.
// Anything else is passed through as-is.
const formatTime = (time: string): string => {
  const parts = time.split(':');
  if (parts.length !== 3) {
    return time;
  }
  const [hours, minutes] = parts;
  const d = new Date();
  d.setHours(Number(hours), Number(minutes), 0);
  return d.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
};

/**
 * Pure helper — return today's trading hours string for a Shop or null when
 * unavailable. Accepts an optional `now` Date for deterministic testing.
 */
export const formatOpenTodayText = (shop: Shop, now: Date = new Date()): string | null => {
  const dayName = getTodayWeekdayKey(now);
  const openTime = shop.regular_hours?.[dayName]?.from;
  const closeTime = shop.regular_hours?.[dayName]?.until;
  if (!openTime || !closeTime) {
    return null;
  }
  return `Open today ${formatTime(openTime)} - ${formatTime(closeTime)}`;
};
